var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2",attrs:{"id":"central"}},[_c('div',{attrs:{"id":"tab-wrapper"}},[_c('TabComponent')],1),_c('div',{attrs:{"id":"router-view-wrapper"}},[_c('router-view',{on:{"logout":(error) => _vm.$emit('logout', error)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }